import type { FaireProductEntity } from "../../entity_types/product";

export const viverano_14: FaireProductEntity = {
  token: "viverano-14",
  type: "product",
  name: "Men's Organic Waffle Weave Spa & Bath Robe (2 Colors)",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/5feed59fafad059e640bbb7282d26d89d3226d43efc15bedecea079948b2fed0.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 48,
  msrpDollars: 82,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-men"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
